/**
 * Lectura de /version.json y estado de actualización (UI).
 * Reutiliza AppVersionGuard sin duplicar lógica de autorefresh.
 * @module services/appVersion.service
 */

import {
  fetchServerVersion,
  readLocalVersionSnapshot,
  readPendingVersion,
  isUpdateAvailable,
  getVersionCheckIntervalMs
} from '../utils/appVersionGuard';

export { getVersionCheckIntervalMs };

/**
 * @returns {Promise<{ version: string, commit: string, builtAt: string }|null>}
 */
export async function fetchAppVersion() {
  try {
    return await fetchServerVersion();
  } catch {
    return null;
  }
}

export function getLocalAppVersionSnapshot() {
  return readLocalVersionSnapshot();
}

export function getPendingAppVersion() {
  return readPendingVersion();
}

/**
 * @returns {'updated'|'update_available'|'unknown'}
 */
export function resolveAppVersionStatus(local, remote, pending) {
  if (!remote?.commit) return 'unknown';
  if (pending) return 'update_available';
  if (local && isUpdateAvailable(local, remote)) return 'update_available';
  return 'updated';
}

export function formatShortCommit(commit) {
  if (!commit) return '—';
  return String(commit).slice(0, 7);
}

export function formatBuiltAt(iso) {
  if (!iso) return '—';
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '—';
    return d.toLocaleString('es-AR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch {
    return '—';
  }
}
